import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { PortfolioCard } from "./PortfolioCard";
import { PORTFOLIO } from "@/data/portfolio";

const FEATURED = ["Georgina's Kitchen", "Rigorfield", "MapVanta", "Manya Matrimony", "RCC Pattern", "OSM Stays", "Gati Royal", "Mobile Savvy"];

export const PortfolioPreview = () => {
  const items = FEATURED.map((n) => PORTFOLIO.find((p) => p.name === n)).filter(Boolean);
  return (
    <section className="py-20 md:py-28" data-testid="portfolio-preview" aria-labelledby="portfolio-preview-heading">
      <div className="container-x">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <SectionHead id="portfolio-preview-heading" eyebrow="Our portfolio" title="Websites, Apps and Systems We Have Delivered" intro={`Browse ${PORTFOLIO.length} projects, from business websites and online stores to Android apps, admin panels and CRM systems.`} />
          <Link to="/portfolio" className="btn-ink shrink-0" data-testid="all-portfolio-link">View full portfolio <ArrowRight className="h-4 w-4" aria-hidden /></Link>
        </div>
        <ul className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {items.map((p) => <li key={p.id}><PortfolioCard p={p} /></li>)}
        </ul>
      </div>
    </section>
  );
};
